//Fluxo principal
export const SES_SELECIONAR_REQUERIMENTO = "SES_SELECIONAR_REQUERIMENTO";
export const SES_CONTROL_MODAL_SEGURADO_ESPECIAL =
  "SES_CONTROL_MODAL_SEGURADO_ESPECIAL";
export const SELECIONAR_TIPO_DE_DECLACACAO_SEGURADO_ESPECIAL =
  "SELECIONAR_TIPO_DE_DECLACACAO_SEGURADO_ESPECIAL";
export const ACEITAR_TERMO_VERACIDADE_DECLACACAO_SEGURADO_ESPECIAL =
  "ACEITAR_TERMO_VERACIDADE_DECLACACAO_SEGURADO_ESPECIAL";
export const INICIAR_NOVA_DECLARACAO_SEGURADO_ESPECIAL =
  "INICIAR_NOVA_DECLARACAO_SEGURADO_ESPECIAL";
export const SES_ZERAR_DECLARACAO_SEGURADO_ESPECIAL =
  "SES_ZERAR_DECLARACAO_SEGURADO_ESPECIAL";
export const SET_ERRO_SEGURADO_ESPECIAL = "SET_ERRO_SEGURADO_ESPECIAL";
export const SES_SELECAO_CATEGORIAS_SET_PRIMEIRO_CADASTRO =
  "SES_SELECAO_CATEGORIAS_SET_PRIMEIRO_CADASTRO";
export const SES_CONSULTAR_ID_TAREFA_POR_PROTOCOLO_SUCESSO =
  "SES_CONSULTAR_ID_TAREFA_POR_PROTOCOLO_SUCESSO";
export const SES_ADICIONAR_NOVA_SUCESSO = "SES_ADICIONAR_NOVA_SUCESSO";

//perìdo ATIVIDADE
export const SES_EXCLUSAO_PERIODO_ATIVIDADE_SUCESSO =
  "SES_EXCLUSAO_PERIODO_ATIVIDADE_SUCESSO";
export const SET_PERIODO_ATIVIDADE_NUMERO_RGP =
  "SET_PERIODO_ATIVIDADE_NUMERO_RGP";

//cessão de terra
export const SES_CESSAO_DE_TERRA_CADASTRAR_SUCESSO =
  "SES_CESSAO_DE_TERRA_CADASTRAR_SUCESSO";
export const SES_CESSAO_DE_TERRA_ALTERAR_SUCESSO =
  "SES_CESSAO_DE_TERRA_ALTERAR_SUCESSO";
export const SES_CESSAO_DE_TERRA_CADASTRAR_ERRO =
  "SES_CESSAO_DE_TERRA_CADASTRAR_ERRO";
export const SES_CESSAO_DE_TERRA_EXCLUIR_SUCESSO =
  "SES_CESSAO_DE_TERRA_EXCLUIR_SUCESSO";
export const SES_CESSAO_DE_TERRA_EXCLUIR_POR_PERIODO_SUCESSO =
  "SES_CESSAO_DE_TERRA_EXCLUIR_POR_PERIODO_SUCESSO";
export const SES_CESSAO_DE_TERRA_LISTAR_SUCESSO =
  "SES_CESSAO_DE_TERRA_LISTAR_SUCESSO";
export const SES_CESSAO_DE_TERRA_LISTAR_ERRO =
  "SES_CESSAO_DE_TERRA_LISTAR_ERRO";
export const SES_CESSAO_DE_TERRA_SET_CONFIRMAR =
  "SES_CESSAO_DE_TERRA_SET_CONFIRMAR";
export const SES_CESSAO_DE_TERRA_SET_EXIBIR_MODAL_CESSAO_TERRA_EXCLUSAO =
  "SES_CESSAO_DE_TERRA_SET_EXIBIR_MODAL_CESSAO_TERRA_EXCLUSAO";
export const SES_CESSAO_DE_TERRA_CONSULTAR_SUCESSO =
  "SES_CESSAO_DE_TERRA_CONSULTAR_SUCESSO";
export const SES_CESSAO_DE_TERRA_CONSULTAR_ERRO =
  "SES_CESSAO_DE_TERRA_CONSULTAR_ERRO";
export const SES_CESSAO_DE_TERRA_VALIDAR_PERIODO_SUCESSO =
  "SES_CESSAO_DE_TERRA_VALIDAR_PERIODO_SUCESSO";

//Grupo Familiar
export const SES_GRUPOS_FAMILIARES_CADASTRAR_SUCESSO =
  "SES_GRUPOS_FAMILIARES_CADASTRAR_SUCESSO";
export const SES_GRUPOS_FAMILIARES_LISTAR_SUCESSO =
  "SES_GRUPOS_FAMILIARES_LISTAR_SUCESSO";
export const SES_GRUPOS_FAMILIARES_LISTAR_ERRO =
  "SES_GRUPOS_FAMILIARES_LISTAR_SUCESSO";
export const SES_GRUPOS_FAMILIARES_EDITAR_SUCESSO =
  "SES_GRUPOS_FAMILIARES_EDITAR_SUCESSO";
export const SES_GRUPOS_FAMILIARES_CONSULTAR_SUCESSO =
  "SES_GRUPOS_FAMILIARES_CONSULTAR_SUCESSO";
export const SES_GRUPOS_FAMILIARES_CONSULTAR_ERRO =
  "SES_GRUPOS_FAMILIARES_CONSULTAR_ERRO";
export const SES_GRUPOS_FAMILIARES_EXCLUIR_SUCESSO =
  "SES_GRUPOS_FAMILIARES_EXCLUIR_SUCESSO";
export const SES_GRUPOS_FAMILIARES_SET_EXIBIR_MODAL_CESSAO_TERRA_EXCLUSAO =
  "SES_GRUPOS_FAMILIARES_SET_EXIBIR_MODAL_CESSAO_TERRA_EXCLUSAO";
export const SES_GRUPOS_FAMILIARES_SET_CONDICAO_GRUPO_FAMILIAR =
  "SES_GRUPOS_FAMILIARES_SET_CONDICAO_GRUPO_FAMILIAR";

//Recolhimento de IPI
export const SES_RECOLHIMENTO_IPI_CADASTRAR_SUCESSO =
  "SES_RECOLHIMENTO_IPI_CADASTRAR_SUCESSO";
export const SES_RECOLHIMENTO_IPI_CONSULTAR_SUCESSO =
  "SES_RECOLHIMENTO_IPI_CONSULTAR_SUCESSO";
export const SES_RECOLHIMENTO_IPI_ALTERAR_SUCESSO =
  "SES_RECOLHIMENTO_IPI_ALTERAR_SUCESSO";
export const SES_RECOLHIMENTO_IPI_EXCLUIR_SUCESSO =
  "SES_RECOLHIMENTO_IPI_EXCLUIR_SUCESSO";
export const SES_RECOLHIMENTO_IPI_SET_CONFIRMAR =
  "SES_RECOLHIMENTO_IPI_SET_CONFIRMAR";
export const SES_RECOLHIMENTO_IPI_CONSULTAR_ERRO =
  "SES_RECOLHIMENTO_IPI_CONSULTAR_ERRO";
export const SES_RECOLHIMENTO_IPI_LISTAR_SUCESSO =
  "SES_RECOLHIMENTO_IPI_LISTAR_SUCESSO";
export const SES_RECOLHIMENTO_IPI_LIMPAR_SUCESSO =
  "SES_RECOLHIMENTO_IPI_LIMPAR_SUCESSO";
export const SES_RECOLHIMENTO_IPI_EXCLUIR_POR_PERIODO_SUCESSO =
  "SES_RECOLHIMENTO_IPI_EXCLUIR_POR_PERIODO_SUCESSO";

//empregado
export const SES_EMPREGADO_CADASTRAR_SUCESSO =
  "SES_EMPREGADO_CADASTRAR_SUCESSO";
export const SES_EMPREGADO_ALTERAR_SUCESSO = "SES_EMPREGADO_ALTERAR_SUCESSO";
export const SES_EMPREGADO_CADASTRAR_ERRO = "SES_EMPREGADO_CADASTRAR_ERRO";
export const SES_EMPREGADO_EXCLUIR_SUCESSO = "SES_EMPREGADO_EXCLUIR_SUCESSO";
export const SES_EMPREGADO_EXCLUIR_POR_PERIODO_SUCESSO =
  "SES_EMPREGADO_EXCLUIR_POR_PERIODO_SUCESSO";
export const SES_EMPREGADO_LISTAR_SUCESSO = "SES_EMPREGADO_LISTAR_SUCESSO";
export const SES_EMPREGADO_LISTAR_ERRO = "SES_EMPREGADO_LISTAR_ERRO";
export const SES_EMPREGADO_SET_CONFIRMAR = "SES_EMPREGADO_SET_CONFIRMAR";
export const SES_EMPREGADO_SET_EXIBIR_MODAL_CESSAO_TERRA_EXCLUSAO =
  "SES_EMPREGADO_SET_EXIBIR_MODAL_CESSAO_TERRA_EXCLUSAO";
export const SES_EMPREGADO_CONSULTAR_SUCESSO =
  "SES_EMPREGADO_CONSULTAR_SUCESSO";
export const SES_EMPREGADO_CONSULTAR_ERRO = "SES_EMPREGADO_CONSULTAR_ERRO";
export const SES_EMPREGADO_LIMPAR_SUCESSO = "SES_EMPREGADO_LIMPAR_SUCESSO";

//cooperativa
export const SES_COOPERATIVA_CADASTRAR_SUCESSO =
  "SES_COOPERATIVA_CADASTRAR_SUCESSO";
export const SES_COOPERATIVA_ALTERAR_SUCESSO =
  "SES_COOPERATIVA_ALTERAR_SUCESSO";
export const SES_COOPERATIVA_CADASTRAR_ERRO = "SES_COOPERATIVA_CADASTRAR_ERRO";
export const SES_COOPERATIVA_EXCLUIR_SUCESSO =
  "SES_COOPERATIVA_EXCLUIR_SUCESSO";
export const SES_COOPERATIVA_LISTAR_SUCESSO = "SES_COOPERATIVA_LISTAR_SUCESSO";
export const SES_COOPERATIVA_LISTAR_ERRO = "SES_COOPERATIVA_LISTAR_ERRO";
export const SES_COOPERATIVA_SET_CONFIRMAR = "SES_COOPERATIVA_SET_CONFIRMAR";
export const SES_COOPERATIVA_LIMPAR = "SES_COOPERATIVA_LIMPAR";
export const SES_COOPERATIVA_SET_EXIBIR_MODAL_CESSAO_TERRA_EXCLUSAO =
  "SES_COOPERATIVA_SET_EXIBIR_MODAL_CESSAO_TERRA_EXCLUSAO";
export const SES_COOPERATIVA_CONSULTAR_SUCESSO =
  "SES_COOPERATIVA_CONSULTAR_SUCESSO";
export const SES_COOPERATIVA_CONSULTAR_ERRO = "SES_COOPERATIVA_CONSULTAR_ERRO";
export const SES_COOPERATIVA_POR_PERIODO_SUCESSO =
  "SES_COOPERATIVA_POR_PERIODO_SUCESSO";

//OUTRAS ATIVIDADES
export const SES_OUTRAS_ATIVIDADES_CADASTRAR_SUCESSO =
  "SES_OUTRAS_ATIVIDADES_CADASTRAR_SUCESSO";
export const SES_OUTRAS_ATIVIDADES_ALTERAR_SUCESSO =
  "SES_OUTRAS_ATIVIDADES_ALTERAR_SUCESSO";
export const SES_OUTRAS_ATIVIDADES_CADASTRAR_ERRO =
  "SES_OUTRAS_ATIVIDADES_CADASTRAR_ERRO";
export const SES_OUTRAS_ATIVIDADES_EXCLUIR_SUCESSO =
  "SES_OUTRAS_ATIVIDADES_EXCLUIR_SUCESSO";
export const SES_OUTRAS_ATIVIDADES_LISTAR_SUCESSO =
  "SES_OUTRAS_ATIVIDADES_LISTAR_SUCESSO";
export const SES_OUTRAS_ATIVIDADES_LISTAR_ERRO =
  "SES_OUTRAS_ATIVIDADES_LISTAR_ERRO";
export const SES_OUTRAS_ATIVIDADES_SET_CONFIRMAR =
  "SES_OUTRAS_ATIVIDADES_SET_CONFIRMAR";
export const SES_OUTRAS_ATIVIDADES_SET_EXIBIR_MODAL_CESSAO_TERRA_EXCLUSAO =
  "SES_OUTRAS_ATIVIDADES_SET_EXIBIR_MODAL_CESSAO_TERRA_EXCLUSAO";
export const SES_OUTRAS_ATIVIDADES_CONSULTAR_SUCESSO =
  "SES_OUTRAS_ATIVIDADES_CONSULTAR_SUCESSO";
export const SES_OUTRAS_ATIVIDADES_CONSULTAR_ERRO =
  "SES_OUTRAS_ATIVIDADES_CONSULTAR_ERRO";
export const SES_OUTRAS_ATIVIDADES_POR_PERIODO_SUCESSO =
  "SES_OUTRAS_ATIVIDADES_POR_PERIODO_SUCESSO";

//OUTRAS ATIVIDADES ESPECIFICA
export const SES_EXERCE_ATIVIDADE_RECEBE_OUTRA_RENDA_ESPECIFICA_CADASTRAR_SUCESSO =
  "SES_LISTAR_EXERCE_ATIVIDADE_RECEBE_OUTRA_RENDA_ESPECIFICA_CADASTRAR_SUCESSO ";
export const SES_EXERCE_ATIVIDADE_RECEBE_OUTRA_RENDA_ESPECIFICA_ALTERAR_SUCESSO =
  "SES_EXERCE_ATIVIDADE_RECEBE_OUTRA_RENDA_ESPECIFICA_ALTERAR_SUCESSO";
export const SES_LISTAR_EXERCE_ATIVIDADE_RECEBE_OUTRA_RENDA_ESPECIFICA =
  "SES_LISTAR_EXERCE_ATIVIDADE_RECEBE_OUTRA_RENDA_ESPECIFICA";
export const SES_LISTAR_EXERCE_ATIVIDADE_RECEBE_OUTRA_RENDA_ESPECIFICA_SUCESSO =
  "SES_LISTAR_EXERCE_ATIVIDADE_RECEBE_OUTRA_RENDA_ESPECIFICA_SUCESSO";
export const SES_LISTAR_EXERCE_ATIVIDADE_RECEBE_OUTRA_RENDA_ESPECIFICA_ERRO =
  "SES_LISTAR_EXERCE_ATIVIDADE_RECEBE_OUTRA_RENDA_ESPECIFICA_ERRO";
export const SES_EXERCE_ATIVIDADE_RECEBE_OUTRA_RENDA_ESPECIFICA_LIMPAR =
  "SES_ATIVIDADE_RECEBE_OUTRA_RENDA_ESPECIFICA_LIMPAR";
export const SES_EXERCE_ATIVIDADE_RECEBE_OUTRA_RENDA_ESPECIFICA_SET_CONFIMAR =
  "SES_LISTAR_EXERCE_ATIVIDADE_RECEBE_OUTRA_RENDA_ESPECIFICA_SET_CONFIMAR";
export const SES_EXERCE_ATIVIDADE_RECEBE_OUTRA_RENDA_ESPECIFICA_EXCLUIR_SUCESSO =
  "SES_EXERCE_ATIVIDADE_RECEBE_OUTRA_RENDA_ESPECIFICA_EXCLUIR_SUCESSO";
export const SES_EXERCE_ATIVIDADE_RECEBE_OUTRA_RENDA_ESPECIFICA_CONSULTAR_SUCESSO =
  "SES_EXERCE_ATIVIDADE_RECEBE_OUTRA_RENDA_ESPECIFICA_CONSULTAR_SUCESSO";
export const SES_OUTRAS_ATIVIDADES_ESPECIFICA_SET_CONFIRMAR =
  "SES_OUTRAS_ATIVIDADES_ESPECIFICA_SET_CONFIRMAR";
export const SES_OUTRAS_ATIVIDADES_ESPECIFICA_POR_PERIODO_SUCESSO =
  "SES_OUTRAS_ATIVIDADES_ESPECIFICA_POR_PERIODO_SUCESSO";

//propriedades rurais
export const SES_PROPRIEDADE_RURAL_CADASTRAR_SUCESSO =
  "SES_PROPRIEDADE_RURAL_CADASTRAR_SUCESSO";
export const SES_PROPRIEDADE_RURAL_LISTAR_SUCESSO =
  "SES_PROPRIEDADE_RURAL_LISTAR_SUCESSO";
export const SES_PROPRIEDADE_RURAL_EDITAR_SUCESSO =
  "SES_PROPRIEDADE_RURAL_EDITAR_SUCESSO";
export const SES_PROPRIEDADE_RURAL_CONSULTAR_SUCESSO =
  "SES_PROPRIEDADE_RURAL_CONSULTAR_SUCESSO";
export const SES_PROPRIEDADE_RURAL_EXCLUIR_SUCESSO =
  "SES_PROPRIEDADE_RURAL_EXCLUIR_SUCESSO";
export const SES_PROPRIEDADE_RURAL_LIMPAR = "SES_PROPRIEDADE_RURAL_LIMPAR";
export const SES_PROPRIEDADE_RURAL_SET_EXIBIR_MODAL_CESSAO_TERRA_EXCLUSAO =
  "SES_PROPRIEDADE_RURAL_SET_EXIBIR_MODAL_CESSAO_TERRA_EXCLUSAO";
export const SES_PROPRIEDADE_RURAL_CONSULTAR_PERIODO_SEM_PROPRIEDADE_RURAL_CADASTRADA_SUCESSO =
  "SES_PROPRIEDADE_RURAL_CONSULTAR_PERIODO_SEM_PROPRIEDADE_RURAL_CADASTRADA_SUCESSO";

export const ATUALIZAR_DECLARACAO_SEGURADO_ESPECIAL =
  "ATUALIZAR_DECLARACAO_SEGURADO_ESPECIAL";
export const SES_CATEGORIAS_DECLARACAO_SUCESSO =
  "SES_CATEGORIAS_DECLARACAO_SUCESSO";
export const CADASTRAR_CATEGORIAS_DECLARACAO_SEGURADO_ESPECIAL_ERRO =
  "CADASTRAR_CATEGORIAS_DECLARACAO_SEGURADO_ESPECIAL_ERRO";
export const CADASTRAR_PERIODO_DECLARACAO_SEGURADO_ESPECIAL_SUCESSO =
  "CADASTRAR_PERIODO_DECLARACAO_SEGURADO_ESPECIAL_SUCESSO";
export const SES_ATUALIZAR_PERIODO_DECLARACAO_SUCESSO =
  "SES_ATUALIZAR_PERIODO_DECLARACAO_SUCESSO";
export const SES_ATUALIZAR_PERIODO_DECLARACAO_CONDICAO_GRUPO_FAMILIAR_SUCESSO =
  "SES_ATUALIZAR_PERIODO_DECLARACAO_CONDICAO_GRUPO_FAMILIAR_SUCESSO";

export const CADASTRAR_PERIODO_DECLARACAO_SEGURADO_ESPECIAL_ERRO =
  "CADASTRAR_PERIODO_DECLARACAO_SEGURADO_ESPECIAL_ERRO";
export const SES_CADASTRAR_DADOS_SEGURADO_SUCESSO =
  "SES_CADASTRAR_DADOS_SEGURADO_SUCESSO";
export const SES_CADASTRAR_DADOS_SEGURADO_ERRO =
  "SES_CADASTRAR_DADOS_SEGURADO_ERRO";
export const SES_CONSULTAR_CATEGORIAS_ATIVIDADE_RURAL_SUCESSO =
  "SES_CONSULTAR_CATEGORIAS_ATIVIDADE_RURAL_SUCESSO";
export const SES_CONSULTAR_CATEGORIAS_ATIVIDADE_RURAL_ERRO =
  "SES_CONSULTAR_CATEGORIAS_ATIVIDADE_RURAL_ERRO";
export const SES_CADASTRAR_NUMERO_RGP_SUCESSO =
  "SES_CADASTRAR_NUMERO_RGP_SUCESSO";

export const SES_ADIAR_PREENCHIMENTO_DE_AUTODECLARACAO_SUCESSO =
  "SES_ADIAR_PREENCHIMENTO_DE_AUTODECLARACAO_SUCESSO";
export const SES_CONCLUIR_PREENCHIMENTO_SUCESSO =
  "SES_CONCLUIR_PREENCHIMENTO_SUCESSO";
export const SES_CONCLUIR_PREENCHIMENTO_TODAS_SUCESSO =
  "SES_CONCLUIR_PREENCHIMENTO_TODAS_SUCESSO";
export const SES_RESET_AUTODECLARACOES_SUCESSO =
  "SES_RESET_AUTODECLARACOES_SUCESSO";

export const SES_CONSULTAR_ADIAR_PREENCHIMENTO_DE_AUTODECLARACAO_SUCESSO =
  "SES_CONSULTAR_ADIAR_PREENCHIMENTO_DE_AUTODECLARACAO_SUCESSO";

export const SES_BUSCAR_PERIODO_ATIVIDADE_SUCESSO =
  "SES_BUSCAR_PERIODO_ATIVIDADE_SUCESSO";
export const BUSCAR_DECLARACAO_SEGURADO_ESPECIAL_ERRO =
  "BUSCAR_DECLARACAO_SEGURADO_ESPECIAL_ERRO";
export const BUSCAR_DADOS_SEGURADOS_ESPECIAL_SUCESSO =
  "BUSCAR_DADOS_SEGURADOS_ESPECIAL_SUCESSO";
export const BUSCAR_DADOS_SEGURADOS_ESPECIAL_ERRO =
  "BUSCAR_DADOS_SEGURADOS_ESPECIAL_ERRO";
export const SES_CONSULTAR_DADOS_INTERESSADOS_SUCESSO =
  "SES_CONSULTAR_DADOS_INTERESSADOS_SUCESSO";
export const SES_CONSULTAR_DADOS_INTERESSADOS_ERRO =
  "SES_CONSULTAR_DADOS_INTERESSADOS_ERRO";
export const SES_CONSULTAR_DADOS_SEGURADO_SUCESSO =
  "SES_CONSULTAR_DADOS_SEGURADO_SUCESSO";
export const SES_CONSULTAR_MUNICIPIOS_POR_UF_SUCESSO =
  "SES_CONSULTAR_MUNICIPIOS_POR_UF_SUCESSO";
export const SES_CONSULTAR_MUNICIPIOS_POR_UF_ERRO =
  "SES_CONSULTAR_MUNICIPIOS_POR_UF_ERRO";

export const SES_CONSULTAR_DADOS_SEGURADO_ERRO =
  "SES_CONSULTAR_DADOS_SEGURADO_ERRO";
export const LISTAR_DECLARACOES_SEGURADO_ESPECIAL_POR_ID_TAREFA_SUCESSO =
  "LISTAR_DECLARACOES_SEGURADO_ESPECIAL_POR_ID_TAREFA_SUCESSO";
export const LISTAR_DECLARACOES_SEGURADO_ESPECIAL_POR_ID_TAREFA_ERRO =
  "LISTAR_DECLARACOES_SEGURADO_ESPECIAL_POR_ID_TAREFA_ERRO";

export const SES_CADASTRAR_ATIVIDADE_RURAL_SUCESSO =
  "SES_CADASTRAR_ATIVIDADE_RURAL_SUCESSO";
export const SES_LISTAR_ATIVIDADES_RURAIS_SUCESSO =
  "SES_LISTAR_ATIVIDADES_RURAIS_SUCESSO";
export const SES_LISTAR_ATIVIDADES_RURAIS_EXCLUIR_SUCESSO =
  "SES_LISTAR_ATIVIDADES_RURAIS_EXCLUIR_SUCESSO";
export const SES_LISTAR_ATIVIDADES_RURAIS_EXCLUIR_ERRO =
  "SES_LISTAR_ATIVIDADES_RURAIS_EXCLUIR_ERRO";
export const SES_ATIVIDADES_RURAIS_CONSULTAR_SUCESSO =
  "SES_ATIVIDADES_RURAIS_CONSULTAR_SUCESSO";
export const SES_ATIVIDADES_RURAIS_CONSULTAR_ERRO =
  "SES_ATIVIDADES_RURAIS_CONSULTAR_ERRO";
export const SES_ATIVIDADES_RURAIS_EXIBIR_MODAL_EXCLUSAO =
  "SES_ATIVIDADES_RURAIS_EXIBIR_MODAL_EXCLUSAO";

export const SES_LISTAR_EMPREGADO_SUCESSO = "SES_LISTAR_EMPREGADO_SUCESSO";
export const SES_LISTAR_EMPREGADO_ERRO = "SES_LISTAR_EMPREGADO_ERRO";

export const SES_LISTAR_EXERCE_ATIVIDADE_RECEBE_OUTRA_RENDA_GENERICA =
  "SES_LISTAR_EXERCE_ATIVIDADE_RECEBE_OUTRA_RENDA_GENERICA";

export const SES_LISTAR_EXERCE_ATIVIDADE_RECEBE_OUTRA_RENDA_GENERICA_SUCESSO =
  "SES_LISTAR_EXERCE_ATIVIDADE_RECEBE_OUTRA_RENDA_GENERICA_SUCESSO";
export const SES_LISTAR_EXERCE_ATIVIDADE_RECEBE_OUTRA_RENDA_GENERICA_ERRO =
  "SES_LISTAR_EXERCE_ATIVIDADE_RECEBE_OUTRA_RENDA_GENERICA_ERRO";

//set dados declaracao
export const SET_DECLARACAO_SEGURADO_ESPECIAL_ID_TAREFA =
  "SET_DECLARACAO_SEGURADO_ESPECIAL_ID_TAREFA";
export const SET_DECLARACAO_SEGURADO_ESPECIAL_INFORMACOES_VERDADEIRAS =
  "SET_DECLARACAO_SEGURADO_ESPECIAL_INFORMACOES_VERDADEIRAS";
export const SET_DECLARACAO_SEGURADO_ESPECIAL_EH_PRODUTOR_RURAL_PESCADOR_SERINGUEIRO =
  "SET_DECLARACAO_SEGURADO_ESPECIAL_EH_PRODUTOR_RURAL_PESCADOR_SERINGUEIRO";
export const SET_DECLARACAO_SEGURADO_ESPECIAL_EH_INDIGENA =
  "SET_DECLARACAO_SEGURADO_ESPECIAL_EH_INDIGENA";
export const SET_DECLARACAO_SEGURADO_ESPECIAL_EH_EMPREGADO_RURAL =
  "SET_DECLARACAO_SEGURADO_ESPECIAL_EH_EMPREGADO_RURAL";

export const SET_DECLARACAO_SEGURADO_ESPECIAL_ACEITE_FINALIZAR_REQUERIMENTO =
  "SET_DECLARACAO_SEGURADO_ESPECIAL_ACEITE_FINALIZAR_REQUERIMENTO";
export const SET_DECLARACAO_SEGURADO_ESPECIAL_TIPO_DECLARACAO =
  "SET_DECLARACAO_SEGURADO_ESPECIAL_TIPO_DECLARACAO";
export const SET_DECLARACAO_SEGURADO_ESPECIAL_CONDICAO_IMOVEL =
  "SET_DECLARACAO_SEGURADO_ESPECIAL_CONDICAO_IMOVEL";
export const SET_DECLARACAO_SEGURADO_ESPECIAL_SITUACAO_FAMILIAR =
  "SET_DECLARACAO_SEGURADO_ESPECIAL_SITUACAO_FAMILIAR";
export const SET_DECLARACAO_SEGURADO_ESPECIAL_DT_INICIO =
  "SET_DECLARACAO_SEGURADO_ESPECIAL_DT_INICIO";
export const SET_DECLARACAO_SEGURADO_ESPECIAL_DT_FIM =
  "SET_DECLARACAO_SEGURADO_ESPECIAL_DT_FIM";
export const SET_DECLARACAO_SEGURADO_ESPECIAL_CODIGO_LOCAL_EXERCE_ATIVIDADE_PESCADOR =
  "SET_DECLARACAO_SEGURADO_ESPECIAL_CODIGO_LOCAL_EXERCE_ATIVIDADE_PESCADOR";
export const SET_DECLARACAO_SEGURADO_ESPECIAL_LOCAL_ATIVIDADE_RURAL =
  "SET_DECLARACAO_SEGURADO_ESPECIAL_LOCAL_ATIVIDADE_RURAL";
export const SET_DECLARACAO_SEGURADO_ESPECIAL_EXPORTACAO_SUSTENTAVEL =
  "SET_DECLARACAO_SEGURADO_ESPECIAL_EXPORTACAO_SUSTENTAVEL";
export const SET_DECLARACAO_SEGURADO_ESPECIAL_APELIDO =
  "SET_DECLARACAO_SEGURADO_ESPECIAL_APELIDO";
export const SET_DECLARACAO_SEGURADO_ESPECIAL_NOME =
  "SET_DECLARACAO_SEGURADO_ESPECIAL_NOME";
export const SET_DECLARACAO_SEGURADO_ESPECIAL_DT_NASCIMENTO_COMPONENTE =
  "SET_DECLARACAO_SEGURADO_ESPECIAL_DT_NASCIMENTO_COMPONENTE";
export const SET_DECLARACAO_SEGURADO_ESPECIAL_LOCAL_NASCIMENTO =
  "SET_DECLARACAO_SEGURADO_ESPECIAL_LOCAL_NASCIMENTO";
export const SET_DECLARACAO_SEGURADO_ESPECIAL_NU_RG =
  "SET_DECLARACAO_SEGURADO_ESPECIAL_NU_RG";
export const SET_DECLARACAO_SEGURADO_ESPECIAL_LOCAL_EXPEDICAO =
  "SET_DECLARACAO_SEGURADO_ESPECIAL_LOCAL_EXPEDICAO";
export const SET_DECLARACAO_SEGURADO_ESPECIAL_UF =
  "SET_DECLARACAO_SEGURADO_ESPECIAL_UF";
export const SET_DECLARACAO_SEGURADO_ESPECIAL_ENDERECO_RESIDENCIAL =
  "SET_DECLARACAO_SEGURADO_ESPECIAL_ENDERECO_RESIDENCIAL";
export const SET_DECLARACAO_SEGURADO_ESPECIAL_MUNICIPIO =
  "SET_DECLARACAO_SEGURADO_ESPECIAL_MUNICIPIO";
export const SET_DECLARACAO_SEGURADO_ESPECIAL_CPF =
  "SET_DECLARACAO_SEGURADO_ESPECIAL_CPF";
export const SET_DECLARACAO_SEGURADO_ESPECIAL_DATA_EXPEDICAO =
  "SET_DECLARACAO_SEGURADO_ESPECIAL_DATA_EXPEDICAO";
export const SET_DECLARACAO_SEGURADO_ESPECIAL_NUMERO_RGP =
  "SET_DECLARACAO_SEGURADO_ESPECIAL_NUMERO_RGP";
export const SET_DECLARACAO_SEGURADO_ESPECIAL_NUMERO_CEI =
  "SET_DECLARACAO_SEGURADO_ESPECIAL_NUMERO_CEI";
export const SET_DECLARACAO_SEGURADO_ESPECIAL_PESSOA_QUILOMBOLA =
  "SET_DECLARACAO_SEGURADO_ESPECIAL_PESSOA_QUILOMBOLA";

//limpar
export const SES_CESSAO_DE_TERRA_LIMPAR = "SES_CESSAO_DE_TERRA_LIMPAR";
export const SES_LIMPAR_GRUPOS_FAMILIARES = "SES_LIMPAR_GRUPOS_FAMILIARES";
export const SES_LIMPAR_ATIVIDADES_RURAIS = "SES_LIMPAR_ATIVIDADES_RURAIS";
export const SES_LIMPAR_EMPREGADO = "SES_LIMPAR_EMPREGADO";

//controle de tela

export const SES_CURRENT_STEP_WIZARD = "SES_CURRENT_STEP_WIZARD";
export const SES_LOADING = "SES_LOADING";

export const SES_SHOW_FORM_DECLARACAO = "SES_SHOW_FORM_DECLARACAO";
export const SES_SET_PREENCHIMENTO_AUTODECLARACAO_CONCLUIDO_SUCESSO =
  "SES_SET_PREENCHIMENTO_AUTODECLARACAO_CONCLUIDO_SUCESSO";
export const SES_SET_PRAZO_PREENCHIMENTO_AUTODECLARACAO_VENCIDO_SUCESSO =
  "SES_SET_PRAZO_PREENCHIMENTO_AUTODECLARACAO_VENCIDO_SUCESSO";
export const SES_SET_TAREFA_REQUER_AUTODECLARACAO_SUCESSO =
  "SES_SET_TAREFA_REQUER_AUTODECLARACAO_SUCESSO";
export const SES_SET_TAREFA_REQUER_AUTODECLARACAO_ERRO =
  "SES_SET_TAREFA_REQUER_AUTODECLARACAO_ERRO";
export const SES_SHOW_FORM_DADOS_SEGURADO = "SES_SHOW_FORM_DADOS_SEGURADO";

// pescador

export const SES_ARRENDAMENTO_EMBARCACAO_SET_CONFIRMAR =
  "SES_ARRENDAMENTO_EMBARCACAO_SET_CONFIRMAR";
export const SES_DADOS_EMBARCACAO_SUCESSO = "SES_DADOS_EMBARCACAO_SUCESSO";
export const SES_RELACAO_PESCADOR_EMBARCACAO_CADASTRAR_SUCESSO =
  "SES_RELACAO_PESCADOR_EMBARCACAO_CADASTRAR_SUCESSO";
export const SES_RELACAO_PESCADOR_EMBARCACAO_ALTERAR_SUCESSO =
  "SES_RELACAO_PESCADOR_EMBARCACAO_ALTERAR_SUCESSO";
export const SES_RELACAO_PESCADOR_EMBARCACAO_CONSULTAR_SUCESSO =
  "SES_RELACAO_PESCADOR_EMBARCACAO_CONSULTAR_SUCESSO";
export const SES_RELACAO_PESCADOR_EMBARCACAO_CONSULTAR_ERRO =
  "SES_RELACAO_PESCADOR_EMBARCACAO_CONSULTAR_ERRO";
export const SES_RELACAO_PESCADOR_EMBARCACAO_EXCLUIR_SUCESSO =
  "SES_RELACAO_PESCADOR_EMBARCACAO_EXCLUIR_SUCESSO";
export const SES_CONDICAO_PESCADOR_EMBARCACAO_LISTAR_SUCESSO =
  "SES_CONDICAO_PESCADOR_EMBARCACAO_LISTAR_SUCESSO";
export const SES_CONDICAO_PESCADOR_EMBARCACAO_LISTAR_ERRO =
  "SES_CONDICAO_PESCADOR_EMBARCACAO_LISTAR_ERRO";
export const SES_CONDICAO_PESCADOR_EMBARCACAO_LIMPAR =
  "SES_CONDICAO_PESCADOR_EMBARCACAO_LIMPAR";
export const SES_CONDICAO_PESCADOR_EMBARCACAO_VALIDAR_PERIODOS_SUCESSO =
  "SES_CONDICAO_PESCADOR_EMBARCACAO_VALIDAR_PERIODOS_SUCESSO";

// titular
export const SES_TITULAR_CADASTRAR_SUCESSO = "SES_TITULAR_CADASTRAR_SUCESSO";
export const SES_TITULAR_ALTERAR_SUCESSO = "SES_TITULAR_ALTERAR_SUCESSO";
export const SES_TITULAR_LISTAR_SUCESSO = "SES_TITULAR_LISTAR_SUCESSO";
export const SES_TITULAR_LISTAR_ERRO = "SES_TITULAR_LISTAR_ERRO";
export const SES_TITULAR_LIMPAR_SUCESSO = "SES_TITULAR_LIMPAR_SUCESSO";
export const SES_TITULAR_CONSULTAR_SUCESSO = "SES_TITULAR_CONSULTAR_SUCESSO";
export const SES_TITULAR_EXCLUIR_SUCESSO = "SES_TITULAR_EXCLUIR_SUCESSO";

// arrendamento embarcação
export const SES_ARRENDAMENTO_EMBARCACAO_CADASTRAR_SUCESSO =
  "SES_ARRENDAMENTO_EMBARCACAO_CADASTRAR_SUCESSO";
export const SES_ARRENDAMENTO_EMBARCACAO_ALTERAR_SUCESSO =
  "SES_ARRENDAMENTO_EMBARCACAO_ALTERAR_SUCESSO";
export const SES_ARRENDAMENTO_EMBARCACAO_LISTAR_SUCESSO =
  "SES_ARRENDAMENTO_EMBARCACAO_LISTAR_SUCESSO";
export const SES_ARRENDAMENTO_EMBARCACAO_LISTAR_ERRO =
  "SES_ARRENDAMENTO_EMBARCACAO_LISTAR_ERRO";
export const SES_ARRENDAMENTO_EMBARCACAO_LIMPAR_SUCESSO =
  "SES_ARRENDAMENTO_EMBARCACAO_LIMPAR_SUCESSO";
export const SES_ARRENDAMENTO_EMBARCACAO_CONSULTAR_SUCESSO =
  "SES_ARRENDAMENTO_EMBARCACAO_CONSULTAR_SUCESSO";
export const SES_ARRENDAMENTO_EMBARCACAO_EXCLUIR_SUCESSO =
  "SES_ARRENDAMENTO_EMBARCACAO_EXCLUIR_SUCESSO";
export const SES_ARRENDAMENTO_EMBARCACAO_CONSULTAR_ERRO =
  "SES_ARRENDAMENTO_EMBARCACAO_CONSULTAR_ERRO";

export const SES_ACTION_VAZIA = "SES_ACTION_VAZIA";

export const SES_LIMPAR_STATUS_TAREFA = "SES_LIMPAR_STATUS_TAREFA";
